module.exports = __webpack_public_path__ + "img/左3logo.326369a0.png";